module.exports = __webpack_public_path__ + "img/P52-en.e1dc4bab.png";